module.exports = __webpack_public_path__ + "img/ydkb.57c04f4e.png";